 function initNestedLinks() {
  const toggleButtons = document.querySelectorAll('.nested-links--open-toggle');
  if (toggleButtons.length === 0) {
    return;
  }

  toggleButtons.forEach(button => {
    button.addEventListener('click', function () {
      const parentItem = this.closest('.nested-links--item');
      parentItem.classList.toggle('is-open');
      this.classList.toggle('is-open');
      const isExpanded = parentItem.classList.contains('is-open');
      this.setAttribute('aria-expanded', isExpanded);

      const content = parentItem.querySelector('.nested-links-content');
      if (isExpanded) {
        content.style.display = 'block';
      } else {
        content.style.opacity = '0';

        setTimeout(() => {
          content.style.display = 'none';
          content.style.opacity = '1';
        }, 100);
      }
    });
  });

  toggleButtons.forEach(button => {
    const icon = button.querySelector('.toggle-icon');
    if (icon) {
      button.addEventListener('click', function() {
        icon.classList.toggle('rotated');
      });
    }
  });

  if (window.innerWidth > 1024) {
    toggleButtons.forEach(button => {
      const parentItem = button.closest('.nested-links--item');
      parentItem.classList.add('is-open');
      button.classList.add('is-open');
      button.setAttribute('aria-expanded', true);

      const icon = button.querySelector('.toggle-icon');
      if (icon) {
        icon.classList.toggle('rotated');
      }

      const content = parentItem.querySelector('.nested-links-content');
      content.style.display = 'block';
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initNestedLinks();

  document.addEventListener('facetwp-loaded', function() {
    initNestedLinks();
  });
});
